import { useCallback, useMemo, useState } from 'react';
import { isEqual } from 'lodash-es';

export const useSelectedMap = ({ initialState }: { initialState: string[] }) => {
  const [appliedMap, setAppliedMap] = useState<{ [key: string]: boolean }>(() =>
    initialState.reduce((map, key) => ({ ...map, [key]: true }), {}),
  );
  const [selectedMap, setSelectedMap] = useState<{ [key: string]: boolean }>(appliedMap);
  const onSelect = useCallback(
    (id: string) => {
      setSelectedMap((state) => ({ ...state, [id]: !state[id] }));
    },
    [setSelectedMap],
  );
  const selectItem = useCallback((id: string) => () => onSelect(id), [onSelect]);
  const onClearMap = useCallback(() => setAppliedMap({}), [setAppliedMap]);
  const onApplyMap = useCallback(() => setAppliedMap(selectedMap), [selectedMap, setAppliedMap]);
  const selectedCount = useMemo(() => Object.values(selectedMap).filter(Boolean).length, [
    selectedMap,
  ]);
  const appliedSelectionIds = useMemo(
    () => Object.keys(appliedMap).filter((key) => appliedMap[key]),
    [appliedMap],
  );
  const updateSelectedMap = useCallback(() => {
    if (!isEqual(appliedMap, selectedMap)) {
      setSelectedMap(appliedMap);
    }
  }, [appliedMap, selectedMap, setSelectedMap]);

  return {
    onSelect,
    selectItem,
    onClearMap,
    onApplyMap,
    selectedMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  };
};
